import React, { ReactNode } from 'react';

import cx from 'classnames';

import styles from './InputLabel.module.scss';

interface IInputLabelProps {
	htmlFor?: string;
	required?: boolean;
	children: ReactNode;
	className: string;
}

const InputLabel = (props: IInputLabelProps) => {
	const { htmlFor, children, required, className } = props;

	return (
		<label
			htmlFor={htmlFor}
			className={cx(
				styles.labelContainer,
				{
					[styles.labelCursorStyling]: htmlFor,
				},
				className,
			)}
		>
			{children}
			{required ? <span className={styles.required}>*</span> : null}
		</label>
	);
};

export default InputLabel;
